import type { ValidatorResult } from '@/models/validation-result.model';
import type { Warehouse } from '@/types/warehouse.interface';
import { CrudService } from './crud.service';

export class WarehouseService {
  private crudService: CrudService<any>;

  constructor() {
    this.crudService = new CrudService<any>('warehouses');
  }

  public async getWarehouse(accountId: string): Promise<Warehouse | undefined> {
    const validationResult: ValidatorResult<Warehouse> = await this.crudService.do(
      'get',
      `account?accountId=${accountId}`,
      undefined,
      undefined,
      'silent',
    );

    return validationResult?.model;
  }
}
